export const whatsapp = '4497775908';

export const whatsappLinkSupport = `https://wa.me/${whatsapp}?text=Quiero%20contactar%20con%20soporte%20técnico`;
